import { Option } from 'baseui/select';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import GuestName from 'legacy-modules/refund/refund/components/guest-name-column';
import { HeaderCheckbox } from 'legacy-modules/sales/reschedule/header-checkbox';

export const _columns: (props: {
  t: any;
  cruiseRoomList: Option[];
  dispatch?: any;
  name: any;
}) => IColumn<any>[] = ({ t, cruiseRoomList, dispatch, name }) => [
  {
    header: () => <HeaderCheckbox name={name} dispatch={dispatch} />,
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    dataType: ColumnDataType.checkbox,
    checkboxNoLabel: true,
  },
  {
    header: t('common:guest'),
    accessorKey: 'guestName',
    minSize: 150,
    dataType: ColumnDataType.null,
    disabled: true,
    cell: ({ row }) => {
      return <GuestName value={row.original.guestName} />;
    },
  },
  {
    header: t('cruise:cabin'),
    accessorKey: 'cruiseRoomId',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.select,
    options: cruiseRoomList,
    required: true,
  },
  {
    header: t('cruise:cabin_number'),
    accessorKey: 'cruiseRoomNumber',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
    required: true,
  },
  {
    header: t('cruise:deck'),
    accessorKey: 'deck',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
    required: true,
  },
  {
    header: t('ticketSales:basic_fare'),
    accessorKey: 'basicFare',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('ticketSales:port_charge'),
    accessorKey: 'portCharge',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('ticketSales:tax'),
    accessorKey: 'tax',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('ticketSales:tipping'),
    accessorKey: 'tipping',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('cruise:reservation_number'),
    accessorKey: 'description',
    minSize: 150,
    dataType: ColumnDataType.text,
  },
];
